import React from 'react';
import { connect } from 'react-redux';
import { clearScheduleWarnings, updateIntervalsInBackend } from '../../../state/modules/combined-schedules/operations';
import { selectScheduleWarnings } from '../../../state/modules/combined-schedules/selectors';
import ScheduleWarningsPopoverInner from './ScheduleWarningsPopoverInner';

// This is the React version of the ScheduleWarningsPopover and is directly
// connected to Redux
const ScheduleWarningsPopoverConnected = ({
  scheduleWarnings,
  clearScheduleWarnings,
  updateIntervalsInBackend,
  handleUpdated,
  handleDismissed
}) => {
  const handleConfirm = async () => {
    await updateIntervalsInBackend({ ignoreWarnings: true });
    clearScheduleWarnings();
    await (handleUpdated && handleUpdated());
  };

  const handleDismiss = () => {
    clearScheduleWarnings();
    handleDismissed && handleDismissed();
  };

  return (
    <ScheduleWarningsPopoverInner
      warnings={scheduleWarnings}
      handleConfirm={handleConfirm}
      handleDismiss={handleDismiss}
    />
  );
};

const mapStateToProps = state => ({
  scheduleWarnings: selectScheduleWarnings(state)
});

const mapDispatchToProps = {
  clearScheduleWarnings,
  updateIntervalsInBackend
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleWarningsPopoverConnected);
